module.exports = __webpack_public_path__ + "static/img/brees-2009-top.e4df056.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2009-top.jpg
// module id = wprj
// module chunks = 1